import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { BaseAnswerType } from '../../views/types';
import type { SectionsPropsType } from '../types';
import { renderAdvisorMessage } from '../../views/AdvisorMessage';
import { renderUserMessage } from '../../views/UserMessage';
import { renderBuildingTypeButtonGroup } from '../../views/BuildingTypeButtonGroup';
import { buildAnswers, buildUserAnswerMessage } from '../utils';

const SECTION_KEY_NAME = 'buildingType';
const PARAM_NAME = 'buildingType';
const GA_EVENT_NAME = 'articleCategory';

export const buildingTypeSection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler, afterFirstAnswer } = props;
  const answers: BaseAnswerType[] = [
    { id: 0, value: '0', textContents: '一戸建て以外' },
    { id: 1, value: '1', textContents: '一戸建て' },
    { id: 2, value: '2', textContents: '一棟ビル' },
    { id: 3, value: '3', textContents: '一棟マンション' },
    { id: 4, value: '4', textContents: '一棟アパート' },
    { id: 5, value: '5', textContents: '工場・倉庫' },
    { id: 6, value: '6', textContents: '店舗・事務所' },
    { id: 7, value: '7', textContents: 'その他' },
  ];
  const answerHandler = (event: React.MouseEvent<HTMLButtonElement> | React.ChangeEvent<HTMLSelectElement>): void => {
    const { type } = event;
    const currentTarget = type === 'change' ? event.currentTarget as HTMLSelectElement : event.currentTarget as HTMLButtonElement;
    const { textContent, value } = currentTarget;
    const selectedOption = event.currentTarget.querySelector('option:checked');

    if (value !== '0') {
      commonAnswerHandler(PARAM_NAME, textContent || '');

      userAnswers.push({
        keyName: SECTION_KEY_NAME,
        paramName: PARAM_NAME,
        question: '',
        answer: (type === 'change' ? selectedOption.textContent : textContent) || '',
        value: value || '',
      });
    }
  };

  // アドバイザーの吹き出し
  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        物件は一戸建てですか？
      </>
    ),
  });

  // 回答ボタン表示
  const answer = await renderBuildingTypeButtonGroup({
    ...props,
    keyName: SECTION_KEY_NAME,
    answers: buildAnswers({
      keyName: SECTION_KEY_NAME,
      answers,
      answerHandler,
      gaEventName: GA_EVENT_NAME,
    }),
  });

  // 1つ目の回答後にフッターを非表示にする
  afterFirstAnswer();

  // ユーザーの吹き出し
  await renderUserMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: buildUserAnswerMessage(answer.answerText),
  });

  // 回答内容を返却する
  return answer;
};
